import { RouteRecordRaw } from 'vue-router';
export const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: () => import(/* webpackChunkName: "layout" */ '@/layout/layout.vue'),
        redirect: '/layout',
        children: [
            {
                path: 'layout',
                name: 'layout',
                meta: {
                    icon: '',
                    title: '首页',
                    level: '0',
                    isMenu: true
                },
                component: () => import(/* webpackChunkName: "layout" */ '@/views/layout/layout.vue'),
            }
        ]
    },
    {
        path: '/totalLine',
        name: 'totalLine',
        component: () => import(/* webpackChunkName: "totalLine" */ '@/views/totalLine/totalLine.vue')
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue')
    },
    {
        path: '/webIframe',
        name: 'webIframe',
        component: () => import(/* webpackChunkName: "webIframe" */ '@/web/webIframe.vue')
    },
    {
      path: '/:path(.*)',
      component: () => import(/* webpackChunkName: "notFound" */ '@/views/notFound/notFound.vue')
    },
]